import { combineReducers } from "redux";

// Slices
import projectSlice from "./projectData/ProjectSlice";
import functionsSlice from "./functions/functionsSlice";
import peopleSetSlice from "./peopleSet/peopleSetSlice";
import companiesSetSlice from "./companiesSet/companiesSetSlice";
import briefsSlice from "./briefs/briefsSlice";
import insightsSlice from "./insights/insightsSlice";
import searchAisSlice from "./searchAis/searchAisSlice";

// Re-export
export * from ".";
export * from "./functions";
export * from "./peopleSet";
export * from "./companiesSet";
export * from "./insights";
export * from "./briefs";

const projectReducers = combineReducers({
    data: projectSlice,
    functions: functionsSlice,
    peopleSet: peopleSetSlice,
    companiesSet: companiesSetSlice,
    insights: insightsSlice,
    briefs: briefsSlice,
    searchAis: searchAisSlice,
});

export default projectReducers;
